<template>
  <div class="mobilePlayer" :class="$style.playerWrap" ref="playerWrap">
    <div :class="$style.videoPlayer">
      <video ref="videoPlayer" class="video-js" :class="$style.videojs"></video>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n'
import videojs from '@/components/videojs'
import { mapState } from 'vuex'
import { checkPrivilege } from '@/services/api'
import Emitter from 'element-ui/lib/mixins/emitter'
import { errorCodeMap } from '@/utils/errorcodes.js'

require('video.js/dist/video-js.css')
require('./style/player.css')
export default {
  name: 'VideoPlayerMobile',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mixins: [Emitter],
  computed: mapState(['fileInfo']),
  data() {
    return {
      player: null
    }
  },
  mounted() {
    window.HELP_IMPROVE_VIDEOJS = false
    // 尽可能阻止移动端长按出菜单
    this.preventLongPressMenu(this.$refs.playerWrap)
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.dispatch('APP', 'dwReporter', {
        page: 'preview',
        operation: 'show'
      })
      this.player.controlBar.removeChild('PictureInPictureToggle')
      this.player.volume(0.5)
      this.player.tech_.on('retryplaylist', () => {
        let previewType = this.$route.params.sid ? 'link' : 'normal'
        checkPrivilege(this.fileInfo.groupid, previewType).catch((err) => {
          // 当权益接口非200时则表示权益过期，跳转到错误页面
          if (err.detail.type === 'SERVICE_ERROR') {
            this.dispatch('APP', 'showError', {
              info: err.detail.info,
              val: {
                type: i18n.t('919c36e310')
              }
            })
          }
        })
      })
      this.player.tech_.on('play', () => {
        this.dispatch('APP', 'dwReporter', {
          page: 'preview',
          operation: 'play',
          play_time: this.$refs.videoPlayer.currentTime.toFixed(2)
        })
        this.$DwManager.recordPlayTime('play')
        this.$DwManager.reportUserActiveAction('play')
      })
      this.player.tech_.on('pause', () => {
        this.dispatch('APP', 'dwReporter', {
          page: 'preview',
          operation: 'play',
          play_time: this.$refs.videoPlayer.currentTime.toFixed(2)
        })
        this.$DwManager.recordPlayTime('pause')
        this.$DwManager.reportUserActiveAction('pause')
      })
    })
    this.player.on('fullscreenchange', () => {
      // this.player.isFullscreen() f11退出全屏时不准确
      if (
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen
      ) {
        this.dispatch('APP', 'dwReporter', {
          page: 'preview',
          operation: 'fullscreen',
          play_time: this.$refs.videoPlayer.currentTime.toFixed(2)
        })
        this.$DwManager.reportUserActiveAction('fullscreen')
      }
     
    })
    this.player.on('volumechange', (evt) => {
      if (this.$refs.videoPlayer.muted) {
        this.dispatch('APP', 'dwReporter', {
          page: 'preview',
          operation: 'mute',
          play_time: this.$refs.videoPlayer.currentTime.toFixed(2)
        })
      }
      this.$DwManager.reportUserActiveAction('volumechange')
    })
    this.player.on('error', () => {
      // IE10及以下版本不支持播放
      this.dispatch('APP', 'showError', {
        info: {
          code: errorCodeMap.FILETYPE_NOT_SUPPORT
        }
      })
      this.$DwManager.recordInitialPlayStatus(this.$refs.videoPlayer.error.code)
    })


    // dw start
    this.player.on('canplaythrough', () => {
      this.$DwManager.measureFileLoaded('end')
    })
    this.player.on('loadedmetadata', () => {
      this.$DwManager.reportShowAction('video', {
        fileInfo: this.fileInfo, 
        mediaInfo: {
          duration: this.player.duration(),
          width: this.player.videoWidth(),
          height: this.player.videoHeight(),
          poster: this.options.poster
        }
      })
      this.$DwManager.recordTotalTime(this.player.duration())
    })

    this.player.on('waiting', () => {
      this.$DwManager.measureFirstTimeBuffering('start')
    })
    this.player.on('playing', () => {
      this.$DwManager.measureFirstTimeBuffering('end')
    })

    this.player.on('loadstart', () => {
      this.$DwManager.measureFirstFrameLoaded('start')
      this.$DwManager.measureFileLoaded('start')
    })

    this.player.on('loadeddata', () => {
      this.$DwManager.measureFirstFrameLoaded('end')
    })

    this.player.on('ended', () => {
      this.$DwManager.recordPlayTime('ended')
    })
    this.player.on('seeked', () => {
      this.$DwManager.reportUserActiveAction('seeking', 'video')
    })
    // dw end
  },
  methods: {
    preventLongPressMenu(node) {
      node.ontouchstart = this.absorbEvent
      node.ontouchmove = this.absorbEvent
      node.ontouchend = this.absorbEvent
      node.ontouchcancel = this.absorbEvent
    },
    absorbEvent(event) {
      var e = event || window.event
      e.preventDefault && e.preventDefault()
      e.stopPropagation && e.stopPropagation()
      e.cancelBubble = true
      e.returnValue = false
      return false
    }
  },
  destroyed() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
<style lang="scss" module>
.playerWrap {
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-touch-callout: none;
}

.videoPlayer {
  width: 100%;
}
</style>
